import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiPatch, apiDelete } from '../api/client.js';

export const usePosByStore = (storeId) =>
  useQuery({ queryKey: ['pos', storeId], queryFn: () => apiGet(`/stores/${storeId}/pos`), enabled: !!storeId });

export const useCreatePos = (storeId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/stores/${storeId}/pos`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pos', storeId] }),
  });
};

export const useUpdatePos = (storeId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ posId, ...data }) => apiPatch(`/stores/${storeId}/pos/${posId}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pos', storeId] }),
  });
};

export const useDeletePos = (storeId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (posId) => apiDelete(`/stores/${storeId}/pos/${posId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pos', storeId] }),
  });
};

export const useSyncPos = (storeId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (posId) => apiPost(`/stores/${storeId}/pos/${posId}/sync`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pos', storeId] }),
  });
};
